import { useCallback, useMemo, useState } from 'react';
import GoogleMapsApi from 'api-services/GoogleMapsApi';
const getAddressComponentsTransformed = (placeDetails) => {
    const transformed = placeDetails.address_components?.reduce((acc, { long_name, short_name, types }) => ({
        ...acc,
        ...types.reduce((accInner, type) => ({
            ...accInner,
            [type]: {
                long_name,
                short_name
            }
        }), {})
    }), {}) ?? {};
    return { transformed };
};
const useGooglePlaceDetails = () => {
    const [details, setDetails] = useState({ object: null, timestamp: 0 });
    const getDetails = useCallback(async (placeId) => {
        const timestamp = Date.now();
        try {
            const result = await GoogleMapsApi.getPlaceDetails(placeId);
            setDetails((details) => {
                // prevent race conditions (an older request might finish later and override state)
                if (timestamp > details.timestamp) {
                    const object = { ...result, ...getAddressComponentsTransformed(result) };
                    return { object, timestamp };
                }
                else {
                    return details;
                }
            });
        }
        catch {
            // in case of an error clear the list but keep the timestamp
            setDetails((details) => ({ object: null, timestamp: details.timestamp }));
        }
    }, []);
    const clearDetails = useCallback(() => {
        setDetails({ object: null, timestamp: 0 });
    }, []);
    const streetAddress = useMemo(() => {
        const streetName = details.object?.transformed.route?.long_name;
        const streetNo = details.object?.transformed.street_number?.long_name;
        return (streetName || streetNo) && `${streetNo || ''} ${streetName || ''}`.trim();
    }, [details]);
    const city = useMemo(() => details.object?.transformed.locality?.long_name ||
        details.object?.transformed.sublocality?.long_name, [details]);
    const state = useMemo(() => details.object?.transformed.administrative_area_level_1?.long_name, [details]);
    const stateCode = useMemo(() => details.object?.transformed.administrative_area_level_1?.short_name, [details]);
    const zipCode = useMemo(() => details.object?.transformed.postal_code?.long_name, [details]);
    return {
        details: details.object,
        streetAddress,
        city,
        state,
        stateCode,
        zipCode,
        getDetails,
        clearDetails
    };
};
export default useGooglePlaceDetails;
//# sourceMappingURL=useGooglePlaceDetails.js.map